import { TripsOverviewHero } from "components/flexComponents/TripsOverviewHero/TripsOverviewHero";
import { TripsBexApiWrapper } from "components/shared/BexApiWrapper/TripsBexApiWrapper";

export const TripsOverviewHeroWrapper = TripsBexApiWrapper(TripsOverviewHero);
export default TripsOverviewHeroWrapper;
